import Successful from "./components/Successful";

const index = () => {
  return <Successful />;
};

export default index;
